<div class="ap-margin-bottom-4 ap-display-block">
    <div class="ap-flex ap-flex-row ap-justify-content-end ap-align-items-end">
        <div class="ap-flex-1">
            <h2 class="secondary word-break">
                {{ 'tokens.browser.finished.title' | apContent }}
            </h2>
            <p>{{ 'tokens.browser.finished.description' | apContent }}</p>

            <ap-button (onClick)="onLogin()" data-bb="login">
                {{ 'tokens.browser.finished.login' | apContent }}
            </ap-button>
        </div>
    </div>
    @if (getIllustrationName()) {
        <div class="ap-sm-hide ap-justify-content-center">
            <ap-illustration [name]="getIllustrationName()" width="213px" height="187px"> </ap-illustration>
        </div>
    }
</div>
